import type { AutosaveState } from './autosave-selectors';
import { SUCCESS } from '../action/util/action-name-creators';

import { Action } from './utils/state-manager';
import { AUTOSAVED_DRAFT_TYPES } from '../util/autosaved-draft-types';

const InitialState: AutosaveState = {
  commentDrafts: [],
  messageDrafts: [],
};

export const autosaveReducer = (state = InitialState, action: Action) => {
  switch (action.type) {
    case SUCCESS('AUTOSAVE_DRAFT'): {
      const { type, draft } = action.payload;
      const {
        context: { jobApplicantId, employeeId },
      } = draft;
      const drafts =
        type === AUTOSAVED_DRAFT_TYPES.COMMENT ? state.commentDrafts : state.messageDrafts;
      const existingDraftIndex = drafts.findIndex((d: AutosavedDraft) =>
        jobApplicantId
          ? d.context.jobApplicantId === jobApplicantId
          : d.context.employeeId === employeeId,
      );
      if (existingDraftIndex !== -1) {
        drafts[existingDraftIndex] = draft;
      } else {
        drafts.push(draft);
      }

      return { ...state, [`${type}Drafts`]: drafts };
    }
    case SUCCESS('CLEAR_DRAFT'): {
      const { type, context } = action.payload;
      const { jobApplicantId, employeeId } = context;

      const drafts =
        type === AUTOSAVED_DRAFT_TYPES.COMMENT ? state.commentDrafts : state.messageDrafts;
      const newDrafts = drafts.filter((d: AutosavedDraft) =>
        jobApplicantId
          ? d.context.jobApplicantId !== jobApplicantId
          : d.context.employeeId !== employeeId,
      );
      return { ...state, [`${type}Drafts`]: newDrafts };
    }
    default:
      return state;
  }
};
